
import { MEDIO_DE_PAGO } from '../../constants/index'

export const customStyles = {
    rows: {
        style: {
            minHeight: '20px', // override the row height
        }
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            backgroundColor: '#debfb5',
            fontSize: '16px',
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
            fontSize: '15px',
        },
    },
};

const options = { year: 'numeric', month: 'numeric', day: 'numeric' };

const columnasTablaVenta = [
    {
        name: 'Fecha Venta',
        selector: row => {
            return new Date(row.fechaVenta).toLocaleDateString('es-AR', options)
        },
        sortable: true,
        sortFunction: (a, b) => {
            const aTimestamp = new Date(a.fechaVenta).getTime();
            const bTimestamp = new Date(b.fechaVenta).getTime();
            if (aTimestamp > bTimestamp) {
                return 1;
            }
            if (bTimestamp > aTimestamp) {
                return -1;
            }
            return 0;
        },
    }, {
        name: 'Codigo Producto',
        selector: row => {
            return (row.UserId + "." + row.codigoProducto)
        },

        wrap: true,
        sortable: true
    },
    {
        name: 'Descripcion',
        selector: row => {
            return (row.descripcion)
        },
        wrap: true,
        sortable: true
    }, {
        name: 'Ganancia Proveedora',
        selector: row => {
            return (`$${row.quitarGanancia ? row.precio : row.ganancia}`)
        },

        sortable: true
    },
];

const columnasTablaOtros = [
    {
        name: 'Fecha Venta',
        selector: row => {
            return new Date(row.createdAt).toLocaleDateString('es-AR', options)
        },
        sortable: true,
        sortFunction: (a, b) => {
            const aTimestamp = new Date(a.createdAt).getTime();
            const bTimestamp = new Date(b.createdAt).getTime();
            if (aTimestamp > bTimestamp) {
                return -1;
            }
            if (bTimestamp > aTimestamp) {
                return 1;
            }
            return 0;
        },
    }, {
        name: 'Tipo de movimiento',
        selector: row => {
            return row.tipoMovimiento;
        },
        wrap: true,
        sortable: true
    }, {
        name: 'Descripcion',
        selector: row => {
            return (row.descripcion)
        },
        wrap: true,
        sortable: true
    }, {
        name: 'Precio',
        selector: row => {
            return (`$${row.montoProveedor}`)
        },

        sortable: true
    },
];

const columnasTablaCompras = [
    {

        name: 'Fecha Venta',
        selector: row => {
            return new Date(row.createdAt).toLocaleDateString('es-AR', options)
        },
        sortable: true,
        sortFunction: (a, b) => {
            const aTimestamp = new Date(a.createdAt).getTime();
            const bTimestamp = new Date(b.createdAt).getTime();
            if (aTimestamp > bTimestamp) {
                return 1;
            }
            if (bTimestamp > aTimestamp) {
                return -1;
            }
            return 0;
        },
    }, {
        name: 'Codigo Producto',
        selector: row => {
            return (row.ProductoId ? row.ProductoId : row.descripcion.includes("Pago con saldo de la cuenta corriente") ? "02.02" : "Sin codigo")
        },

        wrap: true,
        sortable: true
    }
    , {
        name: 'Descripcion',
        selector: row => {
            return (row.descripcion)
        },
        wrap: true,
        sortable: true
    }, {
        name: 'Precio',
        selector: row => {
            return (`$${row.precioArticulo}`)
        },

        sortable: true
    }, {
        name: 'Medio de pago',
        selector: row => {
            switch (row.medioDePago) {
                case MEDIO_DE_PAGO.CUENTA_CORRIENTE:
                    return "Cuenta Corriente"
                case MEDIO_DE_PAGO.EFECTIVO:
                    return "Efectivo"
                case MEDIO_DE_PAGO.CREDITO_Y_EFECTIVO:
                    return "Cuenta Corriente + Efectivo"
                case MEDIO_DE_PAGO.TC:
                    return "Tarjeta Credito"
                case MEDIO_DE_PAGO.TD:
                    return "Tarjeta Debito"
                case MEDIO_DE_PAGO.EFECTIVO_Y_TC:
                    return "Efectivo + TC"
                case MEDIO_DE_PAGO.EFECTIVO_Y_TD:
                    return "Efectivo + TD"
                case MEDIO_DE_PAGO.CUENTA_CORRIENTE_Y_TC:
                    return "Cuenta C. + TC"
                case MEDIO_DE_PAGO.CUENTA_CORRIENTE_Y_TD:
                    return "Cuenta C. + TD"
                case MEDIO_DE_PAGO.EFECTIVO_Y_TRANSFERENCIA:
                    return "Efectivo + Transferencia"
                case MEDIO_DE_PAGO.CUENTA_CORRIENTE_Y_TRANSFERENCIA:
                    return "Cuenta C. + Transferencia"
                case MEDIO_DE_PAGO.TRANSFERENCIA:
                    return "Transferencia"
                default:
                    return "Ninguno";
            }
        },

        sortable: true
    },
];

const columnasTablaDevoluciones = [
    {
        name: 'Fecha de Devolucion',
        selector: row => {
            return new Date(row.createdAt).toLocaleDateString('es-AR', options)
        },
        sortFunction: (a, b) => {
            const aTimestamp = new Date(a.createdAt).getTime();
            const bTimestamp = new Date(b.createdAt).getTime();
            if (aTimestamp > bTimestamp) {
                return 1;
            }
            if (bTimestamp > aTimestamp) {
                return -1;
            }
            return 0;
        },
        sortable: true
    }, {
        name: 'Codigo Producto',
        selector: row => row.ProductoId,
        wrap: true,
        sortable: true
    }, {
        name: 'Monto',
        selector: (row) => `$${Math.abs(row.montoProveedor)}`
    }
];

const columnasTablaPedidos = [
    {
        name: 'Fecha',
        selector: row => {
            return new Date(row.fecha).toLocaleDateString('es-AR', options)
        },
        sortFunction: (a, b) => {
            const aTimestamp = new Date(a.fecha).getTime();
            const bTimestamp = new Date(b.fecha).getTime();
            if (aTimestamp > bTimestamp) {
                return 1;
            }
            if (bTimestamp > aTimestamp) {
                return -1;
            }
            return 0;
        },
        sortable: true
    }, {
        name: 'Numero venta',
        selector: row => row.numero,
        wrap: true,
        sortable: true
    }, {
        name: 'Total',
        selector: (row) => `$${row.precioTotal ?? 0}`
    },
    {
        name: 'Efectivo',
        selector: (row) => `$${row.pagoEfectivo ?? 0}`
    },
    {
        name: 'Credito',
        selector: (row) => `$${row.pagoCredito ?? 0}`
    },
    {
        name: 'Otros medios',
        selector: (row) => `$${row.otros ?? 0}`
    },
    {
        name: 'Nota Credito',
        selector: (row) => `$${row.pagadoConNotaCredito ?? 0}`
    },
    {
        name: 'Recargo',
        selector: (row) => `$${row.recargo ?? 0}`
    },
    {
        name: 'Medio de pago',
        selector: (row) => `${row.medioDePago ?? 0}`
    },
];

export const columns = (tipoTabla) => {
    if (tipoTabla === "devolucion") return columnasTablaDevoluciones;
    if (tipoTabla === "compra") return columnasTablaCompras;
    if (tipoTabla === "venta") return columnasTablaVenta;
    if (tipoTabla === "devolucion") return [];
    if (tipoTabla === "otros") return columnasTablaOtros;
    if (tipoTabla === "pedidos") return columnasTablaPedidos;
}

export const opcionesdepagina = {
    rowsPerPageText: 'Filas por pagina',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Todo'
}
